import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';

@Component({
  selector: 'app-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrl: './payment-summary.component.scss'
})
export class PaymentSummaryComponent implements OnInit {
  @Input() amountToPay: number = 0;
  paymentInitiation: any;

  constructor(private data: DataService) { }

  ngOnInit(): void {
    this.paymentInitiation = this.data.paymentInitiation$.getValue();
  }
}
